<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-flex
          xs12
          :class="['px-0', { 'd-inline-flex': $vuetify.breakpoint.smAndUp }]"
        >
          <v-flex class="pl-0">
            <div
              class="text-xs-left"
              :class="{
                title: $vuetify.breakpoint.smAndUp,
                subheading: $vuetify.breakpoint.xsOnly
              }"
            >
              {{ lang.select_comment_account }}
            </div>

            <div class="pt-3">
              <v-btn
                :class="[
                  $style.accountIconArea,
                  {
                    [$style.currentAccountIcon]: currentLoggedService === 'clip'
                  }
                ]"
                flat
                class="px-0 mx-1"
                :href="
                  clipAccountInfo.isLoggedIn
                    ? 'javascript:void(0)'
                    : serviceLoginUrl(clipAccountInfo.loginUrl)
                "
                target="_top"
                @click="updateCurrentAccountInfo('clip')"
              >
                <v-badge v-model="clipAccountInfo.isLoggedIn" overlap bottom>
                  <v-img slot="badge" :src="clipIconSrc"></v-img>
                  <vc-share-avatar-image
                    v-if="clipAccountInfo.isLoggedIn"
                    :size="50"
                    :src="clipAccountInfo.userImagePath"
                  >
                  </vc-share-avatar-image>
                  <v-avatar v-else tile size="50">
                    <img :src="clipIconSrc" />
                  </v-avatar>
                </v-badge>
              </v-btn>
              <v-btn
                :class="[
                  $style.accountIconArea,
                  {
                    [$style.currentAccountIcon]:
                      currentLoggedService === 'twitter'
                  }
                ]"
                flat
                class="px-0 mx-1"
                :href="
                  twitterAccountInfo.isLoggedIn
                    ? 'javascript:void(0)'
                    : serviceLoginUrl(twitterAccountInfo.loginUrl)
                "
                target="_top"
                @click="updateCurrentAccountInfo('twitter')"
              >
                <v-badge v-model="twitterAccountInfo.isLoggedIn" overlap bottom>
                  <v-img slot="badge" :src="twitterIconSrc"></v-img>
                  <vc-share-avatar-image
                    v-if="twitterAccountInfo.isLoggedIn"
                    :size="50"
                    :src="twitterAccountInfo.userImagePath"
                  >
                  </vc-share-avatar-image>
                  <v-avatar v-else tile size="50">
                    <img :src="twitterIconSrc" />
                  </v-avatar>
                </v-badge>
              </v-btn>
            </div>
          </v-flex>
        </v-flex>

        <v-flex class="px-0">
          <v-flex class="pl-1 subheading d-inline-flex">
            <v-flex align-self-center class="px-0">
              <v-avatar v-if="isLoggedIn" tile :size="25">
                <img :src="currentCommentAccountIcon" />
              </v-avatar>
            </v-flex>
            <v-flex align-self-center>
              <span v-if="isLoggedIn"> {{ currentCommentAccountName }} </span>
            </v-flex>
            <v-flex align-self-center class="pa-0">
              <v-btn
                class="blue--text mx-0"
                v-show="
                  (twitterAccountInfo.isLoggedIn &&
                    currentLoggedService === 'twitter') ||
                    (facebookAccountInfo.isLoggedIn &&
                      currentLoggedService === 'facebook')
                "
                flat
                :href="currentCommentAccountLogoutUrl"
              >
                <span> {{ lang.logout }} </span>
              </v-btn>
            </v-flex>
          </v-flex>
          <v-textarea
            outline
            :label="
              isLoggedIn ? lang.enter_comment : lang.please_select_account
            "
            v-model="comment"
            :disabled="!isLoggedIn"
            no-resize
            v-validate="'required|max:300'"
            data-vv-name="commentValidation"
            :error-messages="errors.collect('commentValidation')"
            required
            counter="300"
          ></v-textarea>
          <div class="pt-4 text-xs-center">
            <v-btn
              :class="[$style.btnTextStyle, 'headline']"
              large
              color="info"
              :disabled="!isLoggedIn || errors.has('commentValidation')"
              @click="callPostComment"
              :loading="isLoading"
            >
              {{ lang.post_comment }}
            </v-btn>
          </div>
        </v-flex>
      </form>

      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-text class="text-xs-center subheading">
            {{ lang.posted_comment }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              :class="$style.btnTextStyle"
              flat="flat"
              @click="dialog = false"
            >
              {{ lang.close }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import qs from "qs";

const CONTENTS_PAGE_NAME = "contents";
const STARRED_PAGE_NAME = "starred";

export default {
  name: "vc-share-post-comment",
  props: {
    selectedCommentAccount: {
      type: String,
      default: ""
    },
    clipAccountInfo: {
      type: Object,
      default: () => {
        return {
          loginUrl: "",
          userId: 0,
          userName: "",
          userImagePath: "",
          isLoggedIn: false
        };
      }
    },
    twitterAccountInfo: {
      type: Object,
      default: () => {
        return {
          loginUrl: "",
          logoutUrl: "",
          userId: 0,
          userName: "",
          userImagePath: "",
          isLoggedIn: false
        };
      }
    },
    facebookAccountInfo: {
      type: Object,
      default: () => {
        return {
          loginUrl: "",
          logoutUrl: "",
          userId: 0,
          userName: "",
          userImagePath: "",
          isLoggedIn: false
        };
      }
    },
    locale: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          please_select_account: "投稿するアカウントを選択してください",
          enter_comment: "コメントを入力",
          comment_counter: "いま:count文字（あと:max文字）",
          select_comment_account: "投稿するアカウントを選択",
          post_comment: "コメントを投稿",
          logout: "ログアウト",
          comment: "コメント",
          posted_time: "ちょうど今",
          posted_comment: "コメントを投稿しました。",
          close: "閉じる"
        };
      }
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "コメントを入力してください",
          max: {
            string: "コメントは300文字以下で入力してください。"
          }
        };
      }
    },
    localeCode: {
      type: String,
      default: ""
    },
    identificationCode: {
      type: String,
      default: ""
    },
    postComment: {
      type: Function,
      default: () => {}
    },
    isDoubleIframe: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ""
    },
    positionIndex: {
      type: Number,
      default: 0
    },
    isContentsDetailPage: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      clipIconSrc: require("./assets/celsys_official.png"),
      twitterIconSrc: require("./assets/ph_sns_x.png"),
      facebookIconSrc: require("./assets/ph_sns_fb.png"),
      dummyUserProfImage: require("./assets/notLoginImage.png"),
      isLoggedIn: !!(
        this.clipAccountInfo.isLoggedIn ||
        this.twitterAccountInfo.isLoggedIn ||
        this.facebookAccountInfo.isLoggedIn
      ),
      currentLoggedService: "",
      currentUserProfImage: "",
      currentCommentAccountIcon: "",
      currentCommentAccountName: "",
      currentCommentAccountLogoutUrl: "",
      comment: "",
      currentLoggedServiceId: 0,
      dictionary: {
        custom: {
          commentValidation: {}
        }
      },
      isLoading: false,
      dialog: false
    };
  },
  mounted: function() {
    if (
      this.checkSelectedCommentAccountIsLoggedIn(this.selectedCommentAccount)
    ) {
      this.updateCurrentAccountInfo(this.selectedCommentAccount);
    } else {
      if (this.clipAccountInfo.isLoggedIn) {
        this.updateCurrentAccountInfo("clip");
        return;
      }
      if (this.twitterAccountInfo.isLoggedIn) {
        this.updateCurrentAccountInfo("twitter");
        return;
      }
      if (this.facebookAccountInfo.isLoggedIn) {
        this.updateCurrentAccountInfo("facebook");
        return;
      }
    }
    this.dictionary.custom.commentValidation.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.comment
    );
    this.dictionary.custom.commentValidation.max = this.validationLang.max.string
      .replace(":attribute", this.lang.comment)
      .replace(":max", "300");
    this.$validator.localize(this.localeCode, this.dictionary);

    const params = qs.parse(window.location.search.replace("?", ""));
    if (params["scrollto"] === "comment") {
      this.$vuetify.goTo("[data-post-comment]", { offset: -70 });
    }
  },
  methods: {
    serviceLoginUrl(url) {
      if (this.isDoubleIframe) {
        if (this.pageName === CONTENTS_PAGE_NAME) {
          return (
            url +
            "?isDoubleIframe=1&pageName=" +
            this.pageName +
            "&contentsIdentificationCode=" +
            this.identificationCode
          );
        }
        if (this.pageName === STARRED_PAGE_NAME) {
          let urlWithParameters =
            url +
            "?isDoubleIframe=1&pageName=" +
            this.pageName +
            "&contentsIdentificationCode=" +
            this.identificationCode +
            "&positionIndex=" +
            this.positionIndex;

          const { show2dViewer } = qs.parse(
            window.location.search.replace("?", "")
          );
          if (show2dViewer === "1") {
            urlWithParameters = urlWithParameters + "&show2dViewer=1";
          }
          return urlWithParameters;
        }
      }

      if (this.isContentsDetailPage) {
        return url + "?isContentsDetailPage=1";
      }

      return url;
    },
    checkSelectedCommentAccountIsLoggedIn: function(selectedCommentAccount) {
      switch (selectedCommentAccount) {
        case "clip":
          return this.clipAccountInfo.isLoggedIn;
        case "twitter":
          return this.twitterAccountInfo.isLoggedIn;
        case "facebook":
          return this.facebookAccountInfo.isLoggedIn;
      }
    },
    updateCurrentAccountInfo: function(selectedCommentAccount) {
      switch (selectedCommentAccount) {
        case "clip":
          if (this.clipAccountInfo.isLoggedIn) {
            this.currentCommentAccountName = this.clipAccountInfo.userName;
            this.currentCommentAccountIcon = this.clipIconSrc;
            this.currentUserProfImage = this.clipAccountInfo.userImagePath;
            this.currentLoggedService = selectedCommentAccount;
            this.currentLoggedServiceId = this.clipAccountInfo.userId;
          }
          break;
        case "twitter":
          if (this.twitterAccountInfo.isLoggedIn) {
            this.currentCommentAccountName = this.twitterAccountInfo.userName;
            this.currentCommentAccountIcon = this.twitterIconSrc;
            this.currentUserProfImage = this.twitterAccountInfo.userImagePath;
            this.currentLoggedService = selectedCommentAccount;
            this.currentLoggedServiceId = this.twitterAccountInfo.userId;
            this.currentCommentAccountLogoutUrl = this.twitterAccountInfo.logoutUrl;
          }
          break;
        case "facebook":
          if (this.facebookAccountInfo.isLoggedIn) {
            this.currentCommentAccountName = this.facebookAccountInfo.userName;
            this.currentCommentAccountIcon = this.facebookIconSrc;
            this.currentUserProfImage = this.facebookAccountInfo.userImagePath;
            this.currentLoggedService = selectedCommentAccount;
            this.currentLoggedServiceId = this.facebookAccountInfo.userId;
            this.currentCommentAccountLogoutUrl = this.facebookAccountInfo.logoutUrl;
          }
          break;
      }
    },
    callPostComment: function() {
      let thisObject = this;
      this.$validator.validate().then(result => {
        if (!result) {
          return;
        }

        this.isLoading = true;

        let requestData = {
          contentIdentificationCode: this.identificationCode,
          accountProvider: this.currentLoggedService,
          userId: this.currentLoggedServiceId,
          comment: this.comment,
          userDisplayName: this.currentCommentAccountName,
          userImagePath: this.currentUserProfImage,
          postedTime: this.lang.posted_time,
          postedOriginalLocale: this.locale
        };

        this.postComment(requestData).then(function(value) {
          if (value === 0) {
            thisObject.comment = "";
            thisObject.$validator.reset();
            thisObject.isLoading = false;
            thisObject.dialog = true;
          } else {
            thisObject.isLoading = false;
          }
        });
      });
    }
  }
};
</script>

<style module>
.accountIconArea {
  min-width: 5em;
  min-height: 4.5em;
}

.btnTextStyle {
  text-transform: none !important;
}

.currentAccountIcon {
  border: solid 2px;
  border-color: red;
  background-color: #bdbdbd;
}
</style>
